import { Link } from "react-router-dom";
import { useCollections } from "../hooks/useCollections";
import { Loading, EmptyState } from "../components/Spinner";

/**
 * Index of every collection — the shelves the library is organised into.
 *
 * Collections come from `DATA/INPUT/collections.json`, so adding a section
 * (cars, a single year, a particular trip) is a data change: drop an entry in
 * that file, tag the content with it, re-index, and it appears here, in the
 * sidebar, and as a search facet with no code change at all.
 */
export function CollectionsPage() {
  const { collections, loading } = useCollections();

  return (
    <div className="page">
      <div className="container">
        <header className="page__head">
          <p className="eyebrow">Index · Collections</p>
          <h1 className="page__title">Collections</h1>
          <p className="page__intro">
            The whole library, split into shelves. Tags say what something is
            about; a collection says where it lives. Anything marked as its own
            section is kept out of the mixed galleries so it can grow without
            burying the rest — it stays in site search either way.
          </p>
        </header>

        {loading ? (
          <Loading label="Loading collections…" />
        ) : collections.length === 0 ? (
          <EmptyState label="No collections defined yet." />
        ) : (
          <div className="collection-grid">
            {collections.map((collection) => (
              <Link
                key={collection.id}
                to={`/collections/${collection.id}`}
                className="collection-card"
              >
                <div
                  className={`collection-card__cover${
                    collection.coverImageUrl ? "" : " collection-card__cover--empty"
                  }`}
                >
                  {collection.coverImageUrl && (
                    <img src={collection.coverImageUrl} alt="" loading="lazy" />
                  )}
                </div>
                <div className="collection-card__body">
                  <h2 className="collection-card__title">{collection.title}</h2>
                  {collection.blurb && (
                    <p className="collection-card__blurb">{collection.blurb}</p>
                  )}
                  <p className="collection-card__meta mono">
                    {collection.itemCount}{" "}
                    {collection.itemCount === 1 ? "item" : "items"}
                    {collection.separate && " · own section"}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
